import React, { useEffect, useState } from "react";
import "./PainelWhatsApp.css";

const SDK_ZAPI_SRC = "https://app.z-api.io/sdk.js";

const PainelWhatsApp = () => {
  const [status, setStatus] = useState(null);
  const [statusPagamento, setStatusPagamento] = useState(null);
  const [qr, setQr] = useState(null);
  const [hora, setHora] = useState(null);
  const [mensagem, setMensagem] = useState("");
  const [isDesconectando, setIsDesconectando] = useState(false);
  const [isConectando, setIsConectando] = useState(false);
  const [erroSdk, setErroSdk] = useState("");
  const [mostrarQr, setMostrarQr] = useState(false);

  const [mostrarPhoneCode, setMostrarPhoneCode] = useState(false);
  const [telefoneConexao, setTelefoneConexao] = useState("");
  const [codigoTelefone, setCodigoTelefone] = useState("");
  const [isGerandoCodigoTelefone, setIsGerandoCodigoTelefone] = useState(false);
  const [erroCodigoTelefone, setErroCodigoTelefone] = useState("");

  const carregarStatus = async () => {
    try {
      const res = await fetch("/crm-wly/api/whatsapp/painel_whatsapp.php", {
        credentials: "include",
      });

      const data = await res.json();

      const statusNormalizado = String(data.status_conexao || "").toLowerCase();
      const pagamentoNormalizado = String(data.status_pagamento || "").toLowerCase();

      setStatus(statusNormalizado || null);
      setStatusPagamento(pagamentoNormalizado || null);
      setQr(data.qr || null);
      setMensagem(data.mensagem || "");
      setHora(new Date().toLocaleTimeString());
    } catch (err) {
      console.error("Erro ao carregar status do WhatsApp", err);
      setMensagem("Erro ao carregar status do WhatsApp.");
    }
  };

  const carregarScriptSdk = () => {
    return new Promise((resolve, reject) => {
      if (window.ZAPIConnector) {
        resolve(window.ZAPIConnector);
        return;
      }

      const scriptExistente = document.querySelector(
        `script[src="${SDK_ZAPI_SRC}"]`
      );

      if (scriptExistente) {
        scriptExistente.addEventListener("load", () => {
          if (window.ZAPIConnector) {
            resolve(window.ZAPIConnector);
          } else {
            reject(new Error("SDK carregado, mas ZAPIConnector não encontrado."));
          }
        });

        scriptExistente.addEventListener("error", () => {
          reject(new Error("Erro ao carregar SDK da Z-API."));
        });

        return;
      }

      const script = document.createElement("script");
      script.src = SDK_ZAPI_SRC;
      script.async = true;

      script.onload = () => {
        if (window.ZAPIConnector) {
          resolve(window.ZAPIConnector);
        } else {
          reject(new Error("SDK carregado, mas ZAPIConnector não encontrado."));
        }
      };

      script.onerror = () => {
        reject(new Error("Erro ao carregar SDK da Z-API."));
      };

      document.body.appendChild(script);
    });
  };

  const verificarStatusZapi = async () => {
    const res = await fetch("/crm-wly/api/whatsapp/verificar_status_zapi.php", {
      method: "GET",
      credentials: "include",
    });

    const data = await res.json();

    if (!data.success) {
      throw new Error(data.message || "Erro ao verificar status da instância.");
    }

    return data;
  };

  const gerarCodigoTelefone = async () => {
  setErroCodigoTelefone("");
  setCodigoTelefone("");
  setIsGerandoCodigoTelefone(true);

  try {
    const telefoneLimpo = telefoneConexao.replace(/\D/g, "");

    if (!telefoneLimpo) {
      throw new Error("Informe o número do WhatsApp.");
    }

    const res = await fetch("/crm-wly/api/whatsapp/gerar_phone_code.php", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        telefone: telefoneLimpo,
      }),
    });

    const data = await res.json();

    console.log("Resposta gerar_phone_code.php:", data);

    if (!data.success || !data.codigo) {
      throw new Error(
        data.message ||
        data.zapi_response?.message ||
        data.zapi_response?.error ||
        "Não foi possível gerar o código."
      );
    }

    setCodigoTelefone(data.codigo);
  } catch (err) {
    console.error("Erro ao gerar código por telefone:", err);
    setErroCodigoTelefone(err.message || "Erro ao gerar código por telefone.");
  } finally {
    setIsGerandoCodigoTelefone(false);
  }
};

  const conectarViaSDK = async () => {
    setErroSdk("");
    setIsConectando(true);

    try {
      const tokenRes = await fetch(
        "/crm-wly/api/whatsapp/gerar_sdk_connector_token.php",
        {
          method: "GET",
          credentials: "include",
        }
      );

      const tokenData = await tokenRes.json();

      if (!tokenData.success || !tokenData.token) {
        throw new Error(
          tokenData.message || "Não foi possível gerar o token de conexão."
        );
      }

      const ZAPIConnector = await carregarScriptSdk();

      const conectado = await ZAPIConnector.open({
        token: tokenData.token,
      });

      if (conectado) {
        await verificarStatusZapi();
        await carregarStatus();
        setMostrarQr(false);
        alert("WhatsApp conectado com sucesso.");
      } else {
        await carregarStatus();
      }
    } catch (err) {
      console.error("Erro ao conectar via SDK:", err);
      setErroSdk(err.message || "Erro ao conectar WhatsApp.");
    } finally {
      setIsConectando(false);
    }
  };

  const desconectar = async () => {
    const confirmar = window.confirm(
      "Tem certeza que deseja desconectar o WhatsApp?"
    );

    if (!confirmar) return;

    setIsDesconectando(true);

    try {
      const res = await fetch("/crm-wly/api/whatsapp/desconectar.php", {
        method: "POST",
        credentials: "include",
      });

      const data = await res.json();

      if (data.success) {
        alert("WhatsApp desconectado com sucesso.");
        await carregarStatus();
      } else {
        alert(data.message || "Erro ao desconectar.");
      }
    } catch (err) {
      console.error("Erro ao desconectar:", err);
      alert("Erro ao desconectar.");
    } finally {
      setIsDesconectando(false);
    }
  };

  useEffect(() => {
    carregarStatus();

    const interval = setInterval(() => {
      carregarStatus();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const estaConectado = status === "ativo" && statusPagamento === "pago";
  const pagamentoBloqueado = statusPagamento && statusPagamento !== "pago";
  const podeConectar = !estaConectado && statusPagamento === "pago";

  return (
    <div className="painel-h2">
      <h1 style={{ borderBottom: "none" }}>
        Painel de Integração WhatsApp
      </h1>

      <div className="painel-wzp">
        {estaConectado ? (
          <>
            <p style={{ fontSize: 22, fontWeight: 600 }}>
              {mensagem || "WhatsApp conectado com sucesso!"}
            </p>

            <p
              style={{
                marginTop: 8,
                color: "#b8b8c8",
                fontSize: 15,
                lineHeight: 1.5,
              }}
            >
              Sua instância está ativa e pronta para enviar e receber mensagens.
            </p>

            <button
              className="btn-desconectar"
              onClick={desconectar}
              disabled={isDesconectando}
              style={{
                marginTop: 24,
                padding: "12px 22px",
                backgroundColor: isDesconectando ? "#aaa" : "#dc3545",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: isDesconectando ? "not-allowed" : "pointer",
                fontWeight: 700,
              }}
            >
              {isDesconectando ? "Desconectando..." : "Desconectar WhatsApp"}
            </button>
          </>
        ) : pagamentoBloqueado ? (
          <>
            <p style={{ fontSize: 22, fontWeight: 600 }}>
              Integração bloqueada
            </p>

            <p
              style={{
                marginTop: 8,
                color: "#b8b8c8",
                fontSize: 15,
                lineHeight: 1.5,
              }}
            >
              {mensagem || "Integração bloqueada: pagamento em atraso."}
            </p>
          </>
        ) : podeConectar ? (
          <>
            <p style={{ marginTop: 10, fontSize: 22, fontWeight: 600 }}>
              Conecte seu WhatsApp ao Nórea CRM
            </p>

            <p
              style={{
                marginTop: 8,
                color: "#b8b8c8",
                fontSize: 15,
                lineHeight: 1.5,
                maxWidth: 480,
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              Clique no botão abaixo para abrir a tela segura de conexão.
              Você poderá conectar por QR Code, número de telefone ou chave de acesso.
            </p>

            <button
              className="btn-conectar-sdk"
              onClick={conectarViaSDK}
              disabled={isConectando}
              style={{
                marginTop: 24,
                width: "100%",
                maxWidth: 420,
                padding: "14px 22px",
                backgroundColor: isConectando ? "#aaa" : "#25d366",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: isConectando ? "not-allowed" : "pointer",
                fontWeight: 700,
                fontSize: 16,
              }}
            >
              {isConectando ? "Abrindo conexão..." : "Conectar WhatsApp"}
            </button>

            {erroSdk && (
              <p
                style={{
                  color: "#ff6b6b",
                  marginTop: 14,
                  fontSize: 14,
                  lineHeight: 1.4,
                }}
              >
                {erroSdk}
              </p>
            )}

            <div className="wzp-phone-code-toggle">
  <button
    type="button"
    onClick={() => setMostrarPhoneCode((prev) => !prev)}
    className="wzp-phone-code-link"
  >
    {mostrarPhoneCode
      ? "Ocultar conexão por telefone"
      : "Conectar usando número de telefone"}
  </button>
</div>

{mostrarPhoneCode && (
  <div className="wzp-phone-code-box">
    <p className="wzp-phone-code-title">Gerar código de conexão</p>

    <p className="wzp-phone-code-text">
      Informe o número do WhatsApp com DDI. Exemplo: 5511999999999.
    </p>

    <input
      type="text"
      value={telefoneConexao}
      onChange={(e) => setTelefoneConexao(e.target.value)}
      placeholder="5511999999999"
      className="wzp-phone-code-input"
    />

    <button
      type="button"
      onClick={gerarCodigoTelefone}
      disabled={isGerandoCodigoTelefone}
      className="wzp-phone-code-button"
    >
      {isGerandoCodigoTelefone ? "Gerando código..." : "Gerar código"}
    </button>

    {erroCodigoTelefone && (
      <p className="wzp-phone-code-error">
        {erroCodigoTelefone}
      </p>
    )}

    {codigoTelefone && (
      <div className="wzp-phone-code-result">
        <p className="wzp-phone-code-label">Código de conexão:</p>

        <div className="wzp-phone-code-value">
          {codigoTelefone}
        </div>

        <button
          type="button"
          onClick={() => navigator.clipboard.writeText(codigoTelefone)}
          className="wzp-phone-code-copy"
        >
          Copiar código
        </button>

        <p className="wzp-phone-code-help">
          Agora abra o WhatsApp no celular, vá em aparelhos conectados e use
          a opção de conectar com número de telefone para inserir este código.
        </p>
      </div>
    )}
  </div>
)}

            {mostrarQr && (
              <div style={{ marginTop: 24 }}>
                {qr ? (
                  <>
                    <p style={{ marginBottom: 14 }}>
                      Escaneie o QR Code abaixo pelo WhatsApp:
                    </p>

                    <div
                      style={{
                        border: "1px solid rgba(255,255,255,0.18)",
                        borderRadius: 8,
                        padding: 16,
                        display: "inline-block",
                      }}
                    >
                      <img src={qr} alt="QR Code" />
                    </div>

                    <p className="hora-atualizacao">
                      Atualizado às: {hora}
                    </p>
                  </>
                ) : (
                  <p style={{ marginTop: 18 }}>
                    {mensagem || "Gerando QR Code..."}
                  </p>
                )}
              </div>
            )}
          </>
        ) : (
          <p>{mensagem || "Carregando status do WhatsApp..."}</p>
        )}
      </div>
    </div>
  );
};

export default PainelWhatsApp;